import Api from '@/services/Api'

export default {
    consulSaldContByVigencia(fecha){
        return Api().get('contratoSaldos/getAllSaldosContablesByVig/'+fecha)
    },
    getContratoSaldosByVig(fecha){
        return Api().get('contratoSaldos/getContratoSaldosByVigencia/'+fecha)
    },
    getContratoSaldosByContrAndVigen(contrato,fecha){
        return Api().get('contratoSaldos/getContratoSaldosByContratoAndVigencia/'+contrato+'/'+fecha)
    },
    getCuentasSaldosByVig(fecha){
        return Api().get('contratoCuentas/getContratoCuentasByVigencia/'+fecha)
    },
    getContratosSaldosByVigCuent(fecha,cuenta){
        return Api().get('contratoCuentas/getContratoByVigenciaAndCuentas/'+fecha+'/'+cuenta)
    },
    generaSaldosContables(info){
        return Api().post('contratoSaldos/generaSaldosContables',info)
    },
    consultaComprobanteContable(vig){
        return Api().get('contratoSaldos/consComprobanteContable/'+vig)
    },
    consultaListadoCausacion(vig){
        return Api().get('contratoSaldos/consListadoCausacion/'+vig)
    },
    getListadoFechas(){
        return Api().get('contratoSaldos/getAllFechas')
    },
}